import React from "react";

interface IInput {
  label: string;
  isRequired?: boolean;
  textArea?: boolean;
  value?: string;
  disabled?: boolean;
  onChange: (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void;
}

const Input = ({
  label,
  isRequired = false,
  textArea = false,
  value = "",
  disabled = false,
  onChange,
}: IInput) => {
  return (
    <div className="flex flex-col w-full">
      <label
        htmlFor={label}
        className="uppercase font-bold my-2 flex text-sm lg:text-base text-secondary"
      >
        {label}
        {isRequired && <span className="text-complementary ml-2">*</span>}
      </label>

      {textArea ? (
        <textarea
          id={label}
          required={isRequired}
          value={value}
          onChange={onChange}
          disabled={disabled}
          className="focus:outline-none focus:bg-black/30 transition-all h-full rounded-2xl text-sm lg:text-base p-4 text-primary/80 mb-5 bg-black/[0.2] resize-none"
        />
      ) : (
        <input
          id={label}
          required={isRequired}
          value={value}
          onChange={onChange}
          disabled={disabled}
          className="focus:outline-none focus:bg-black/30 transition-all h-12 rounded-2xl text-sm lg:text-base p-4 text-primary/80 mb-5 bg-black/[0.2]"
        />
      )}
    </div>
  );
};

export default Input;
